module.exports = __webpack_public_path__ + "img/status-wallet.0076a286.png";